import headerImg from "assets/images/v148/header.webp"
import infoImg from "assets/images/v148/info.webp"

export const v148Config = {
  header: { en: headerImg },
  info: { en: infoImg },
}
